import React, { useState, useEffect, Suspense } from 'react';
import Cookies from 'js-cookie';
import Analytics from '../services/analytics';

interface DisclaimerModalProps {
  onClose: () => void;
}

const DisclaimerModal: React.FC<DisclaimerModalProps> = ({ onClose }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    // Log when disclaimer is shown
    Analytics.trackDisclaimerEvent('disclaimer_display');
  }, []);

  const handleAccept = () => {
    // Log when disclaimer is accepted
    Analytics.trackDisclaimerEvent('disclaimer_accept', dontShowAgain ? '90Days' : '60Mins');

    if (dontShowAgain) {
      // Set cookie to expire in 90 days
      Cookies.set('disclaimerAccepted', 'true', { expires: 90 });
    } else {
      // Set cookie to expire in 60 minutes
      const oneHour = new Date(new Date().getTime() + 60 * 60 * 1000);
      Cookies.set('disclaimerAccepted', 'true', { expires: oneHour });
    }
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-body">
          <h2>✋ WELCOME TO FAT SCIENTIST</h2>
          <p>Please understand before proceeding:</p>
          <ul>
            <li>This site is informational only and is NOT medical advice.</li>
            <li>Always confirm dosages with your healthcare provider.</li>
            <li>Unsure about concentration? Ask your pharmacist or healthcare provider—never guess.</li>
          </ul>

          <p>
            By clicking below, you acknowledge that Productist LLC (Fat Scientist) is not responsible for any harm from
            using this tool. You accept full responsibility for verifying all calculations.
          </p>
          <button onClick={handleAccept} className="accept-button">
            I UNDERSTAND AND ACCEPT RESPONSIBILITY
          </button>
          <div className="checkbox-container">
            <label>
              <input type="checkbox" checked={dontShowAgain} onChange={e => setDontShowAgain(e.target.checked)} />
              Don't show again for 90 days
            </label>
          </div>
        </div>
      </div>
      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          contain: layout paint style;
          will-change: opacity;
        }

        .modal-content {
          background-color: white;
          padding: 2rem;
          border-radius: 8px;
          width: min(90%, 800px);
          max-height: 90vh;
          overflow-y: auto;
          contain: content;
          transform: translateZ(0);
        }

        @media (min-width: 1200px) {
          .modal-content {
            width: min(90%, 1000px);
          }
        }

        .modal-body {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          contain: content;
        }

        .modal-body h2 {
          color: #252441;
          margin-bottom: 1rem;
          font-size: clamp(1.2rem, 4vw, 1.5rem);
        }

        .modal-body p,
        .modal-body li {
          font-size: clamp(0.9rem, 2vw, 1.1rem);
          line-height: 1.5;
        }

        .modal-body ul {
          margin: 0;
          padding-left: 0;
          list-style: none;
        }

        .modal-body li {
          margin-bottom: 0.5rem;
          padding-left: 1.8rem;
          position: relative;
        }

        .modal-body li:before {
          content: "⚠️";
          position: absolute;
          left: 0;
          top: -1px;
        }

        .checkbox-container {
          margin: 0.5rem 0 0 0;
          font-size: clamp(0.8rem, 2vw, 0.9rem);
          color: #666;
        }

        .checkbox-container label {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          cursor: pointer;
        }

        .checkbox-container input[type="checkbox"] {
          width: auto;
          margin: 0;
          cursor: pointer;
        }

        .accept-button {
          background-color: #252441;
          color: white;
          padding: 1rem;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-weight: bold;
          width: 100%;
          margin-top: 0.5rem;
          font-size: clamp(0.9rem, 2vw, 1.1rem);
          transition: background-color 0.2s ease;
          will-change: background-color;
        }

        .accept-button:hover {
          background-color: #0056b3;
        }
      `}</style>
    </div>
  );
};

export default DisclaimerModal;
